import { Navigate, Outlet, useLocation } from "react-router-dom";

export const SupportRoute = (role: any) => {
  const location = useLocation();

  if (!role) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <Outlet />;
};
